import { Box, HStack } from '@chakra-ui/react'
import { useContext } from 'react'
import { CanvasDraw, CanvasDrawContext } from '../../componentsF/canvasF/drawF/CanvasDrawF'
import { DrawControls } from '../../componentsF/canvasF/drawF/DrawControlsF'
import { gameDrawDims } from '../sharedF/constantsF.mts'
import { renderGameCanvasBg } from '../../sharedF/canvasF/renderFinishedTrailsF.mts'
import { NagArea } from './TelDrawGame/NagAreaF.jsx'

const BudgetEl = () => {
  const {usedPct} = useContext(CanvasDrawContext)

  return <HStack {...{justifyContent: 'space-between', fontWeight: 'bold', fontSize: 'lg'}}>
    <Box {...{textAlign: 'center'}}>
      Remaining Ink: {Math.round((1 - usedPct) * 100)}%
    </Box>
    <NagArea />
  </HStack>
}

export const CanvasGameDraw = (props) => {
  const showBudget = <BudgetEl />

  const canvasStyle = {
    border: '1px solid black',
    background: 'white',
  }
  const pixelBudget = 4000
  const DrawControlsComp = DrawControls
  const {width, height} = gameDrawDims

  const redrawFnc = ({ctx}) => renderGameCanvasBg({ctx, width, height})

  return <CanvasDraw {...{
    width, height, redrawFnc,
    showBudget, pixelBudget, DrawControlsComp,
    canvasStyle, budgetAction: 'stop', ...props
  }} />
}